import React from "react";
import memoizeOne from "memoize-one";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import TaskStatus from "./task-status";
import {
  OnboardingStep2ClassName,
  OnboardingStep3ClassName,
  OnboardingStep4ClassName
} from './ducks/reducer';
import FilmanizeCheckbox from "../../../../shared/filmanize-checkbox";

const ScenesOrderList = ({
  taskStatuses,
  filmId,
  updateTaskStatusOrder,
  onUpdateScenesOrder,
  selectedSceneIds,
  draggingSceneId,
  toggleSelection,
  toggleSelectionInGroup,
  multiSelectTo,
  unselectAll,
  readOnly,
  pristine,
  canAccessSceneSettings,
  allSceneNumbersAreInteger,
  renumber,
  setRenumber
}) => {
  const onDragEnd = (result) => {
    if (!result.destination) {
      // dropped outside the list
      return;
    }

    updateTaskStatusOrder(
      result.source.index,
      result.destination.index,
      result.source.droppableId,
      result.destination.droppableId
    );
  };

  const onDragStart = (start) => {
    const id = start.draggableId;
    const selected = selectedSceneIds.find((sceneId) => sceneId === id);

    // if dragging an item that is not selected - unselect all items
    if (!selected) {
      unselectAll();
    }

    // setDraggingSceneId(start.draggableId);
  };

  const grid = 8;

  console.log("selectedSceneIds", selectedSceneIds);

  const getDayStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    // change background colour if dragging
    background: isDragging ? "#947eed" : "#947EED",

    // styles we need to apply on draggables
    ...draggableStyle
  });

  type SceneIdMap = {
    [sceneId: string]: true;
  };

  const getSelectedMap = memoizeOne((selectedSceneIds: string[]) =>
    selectedSceneIds.reduce(
      (previous: SceneIdMap, current: string): SceneIdMap => {
        previous[current] = true;
        return previous;
      },
      {}
    )
  );

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable" >
          {(provided, snapshot) => (

            <table
              className="table"
              {...provided.droppableProps}
              ref={provided.innerRef}>
              <thead>
                <tr>
                  <th>Status</th>
                </tr>
              </thead>

              {(taskStatuses || []).map((taskStatus, index) => {
                const selectionMap = getSelectedMap(
                  selectedSceneIds || []
                );
                const isSelected = selectionMap && taskStatus
                  ? selectionMap[taskStatus.sceneId]
                  : false;
                const isGhosting: boolean =
                  isSelected &&
                  Boolean(draggingSceneId) &&
                  draggingSceneId !== taskStatus.id;
                return (
                  <TaskStatus
                    filmId={filmId}
                    taskStatus={taskStatus}
                    index={index}
                    key={taskStatus?.sceneId ?? index}
                    isSelected={isSelected}
                    isGhosting={isGhosting}
                    selectionCount={(selectedSceneIds || []).length}
                    toggleSelection={toggleSelection}
                    toggleSelectionInGroup={toggleSelectionInGroup}
                    multiSelectTo={multiSelectTo}
                    readOnly={readOnly}
                    canAccessSceneSettings={canAccessSceneSettings}></TaskStatus>
                );
              })}
              {provided.placeholder}
            </table>
          )}
        </Droppable>
      </DragDropContext>

      {!readOnly && <div className="buttons sticky-buttons mt-1">
        <div>
          <button
            type="submit"
            className="button"
            disabled={pristine}
            onClick={() => onUpdateScenesOrder(taskStatuses)}>
            Save
          </button>
        </div>
      </div>}
    </>
  );
};

export default ScenesOrderList;
